import { SharedState } from 'app/types-shared';

export const getCodeMappingAccess =
  (sharedState: SharedState): boolean =>
    sharedState?.access?.adminPanel?.interfaceAdministration?.administrationCentral || false;
